import { render, staticRenderFns } from "./mobileLayout.vue?vue&type=template&id=da72439e&scoped=true&"
import script from "./mobileLayout.vue?vue&type=script&lang=js&"
export * from "./mobileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da72439e",
  null
  
)

export default component.exports